// extracted by mini-css-extract-plugin
module.exports = {"player":"player_player__RX4dI","button":"player_button__36JTc"};